import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5631b340&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631b340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5631b340')) {
      api.createRecord('5631b340', component.options)
    } else {
      api.reload('5631b340', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5631b340&scoped=true", function () {
      api.rerender('5631b340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logModule/callLog/index.vue"
export default component.exports